import React from 'react';
import { useDispatch } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import { Grid } from '@material-ui/core';
import {
    MainHeading,
    SubHeading,
    UserHeading,
    To,
    CloseIcon,
    User,
    Username,
    Line,
    ValidDates,
    TextBold,
    Designation,
    BottomNavigationButtonContainer,
    UpdateProxyPopupContainer,
} from './index.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import UserEmphasis from 'src/assets/images/UserEmphasis.svg';
import {
    setCommonCancel,
    setIsEdit,
} from 'src/pages/more/redux/actions/index.js';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
    setRevokeProxy,
    setAdminUpdatePopup,
} from 'src/pages/admin/redux/action';
import { getDisplayDate } from 'src/utils/dateUtils';

const RevokeProxy = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onSave = () => {
        dispatch(setRevokeProxy(props.revokeProxyData.proxyUid));
        dispatch(setIsEdit(false));
        dispatch(setAdminUpdatePopup(false));
        props.handleClose();
    };

    const onCancel = () => {
        props.handleClose();
        dispatch(setAdminUpdatePopup(true));
        dispatch(setCommonCancel(true));
        dispatch(setIsEdit(false));
    };
    return (
        <>
            <UpdateProxyPopupContainer>
                <Grid
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <Grid
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        mobile={11}
                    >
                        <MainHeading>
                            {t('proxies.revokeAProxy.heading')}
                        </MainHeading>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} mobile={1}>
                        <CloseIcon
                            id="page-admin-revokeProxy-close"
                            mobilePath={Close}
                            onClick={props.handleClose}
                            show={true}
                            ipadMarginLeft={'70%'}
                        />
                    </Grid>
                </Grid>
                <UserHeading>{t('proxies.revokeAProxy.user')}</UserHeading>
                <div
                    style={{
                        display: 'inline-flex',
                        padding: '11.88px 0 0 0',
                    }}
                >
                    <img
                        src={UserEmphasis}
                        alt={'.png'}
                        width={'31.7px'}
                        height={'31.7px'}
                    />
                    <User>
                        <Username>
                            {props.revokeProxyData.proxyEmployee.displayName}
                        </Username>
                        <Designation>
                            {' '}
                            {props.revokeProxyData.proxyEmployee.employeeRole}
                        </Designation>
                    </User>
                </div>
                <ValidDates>{t('proxies.revokeAProxy.validDates')}</ValidDates>
                <Grid
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <Grid item xs={12} sm={3} md={6} lg={6} xl={6} mobile={12}>
                        <To>
                            {getDisplayDate(props.revokeProxyData.fromDate)}{' '}
                            {t('proxies.revokeAProxy.to')}{' '}
                            {props.revokeProxyData.toDate
                                ? getDisplayDate(props.revokeProxyData.toDate)
                                : t('proxies.noEndDate')}
                        </To>
                    </Grid>
                </Grid>
                <SubHeading>{t('proxies.revokeAProxy.subHeading')}</SubHeading>
                <Line />

                <BottomNavigationButtonContainer
                    ipadPadding={'0px 27px 0px 0px'}
                    mbPadding={'0px 0px 0px 0px'}
                >
                    <Button
                        id={'page-admin-revokeProxy-cancel'}
                        clearNotes
                        show={true}
                        //cancel={true}
                        variant={ButtonStyles.cancel}
                        width={'102px'}
                        height={'38px'}
                        mobileWidth={'144px'}
                        margin={'16px 4px 0px 4px'}
                        mobileMargin={'15px 5px 10px 15px'}
                        clicked={onCancel}
                    >
                        <TextBold color={'#140F4B'}>
                            {t('proxies.revokeAProxy.cancel')}
                        </TextBold>
                    </Button>
                    <Button
                        id={'page-admin-revokeProxy-continue'}
                        show
                        //primary={true}
                        variant={ButtonStyles.primary}
                        width={'102px'}
                        height={'38px'}
                        mobileWidth={'144px'}
                        mobileMargin={'15px 15px 10px 10px'}
                        margin={'16px 4px 0px 4px'}
                        clicked={onSave}
                    >
                        <TextBold color={'#FFFF'}>
                            {t('proxies.revokeAProxy.continue')}
                        </TextBold>
                    </Button>
                </BottomNavigationButtonContainer>
            </UpdateProxyPopupContainer>
        </>
    );
};
export default RevokeProxy;
